export interface MembershipTier {
  id: string;
  name: string;
  price: number; // monthly price
  includedVideos: number; // videos included per month
  additionalVideoPrice: number; // price per additional video
  features: string[];
  sportSpecific?: boolean;
}

export interface UserMembership {
  userId: string;
  tier: string;
  sport?: 'pickleball' | 'tennis' | 'golf';
  startDate: Date;
  endDate: Date;
  videosUsedThisMonth: number;
  videosIncluded: number;
  totalVideosPurchased: number;
  isActive: boolean;
}

export interface VideoAnalysisUsage {
  userId: string;
  videoId: string;
  sport: 'pickleball' | 'tennis' | 'golf';
  timestamp: Date;
  cost: number;
  analysisType: 'included' | 'purchased';
}

export const MEMBERSHIP_TIERS: MembershipTier[] = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    includedVideos: 0,
    additionalVideoPrice: 0,
    features: [
      'Basic drills and techniques',
      'Equipment recommendations',
      'Fundamentals content',
      'Basic shot analysis (text)',
      'Skill assessments',
      'Profile tracking'
    ]
  },
  {
    id: 'premium-pickleball',
    name: 'Pickleball Premium',
    price: 9.99,
    includedVideos: 5,
    additionalVideoPrice: 5.00,
    sportSpecific: true,
    features: [
      '5 video analyses per month included',
      'Additional analyses: $5 each',
      'Shot analysis & Your Online Coach',
      'Expert content (Ben Johns)',
      'Progress tracking'
    ]
  },
  {
    id: 'premium-tennis',
    name: 'Tennis Premium',
    price: 9.99,
    includedVideos: 5,
    additionalVideoPrice: 5.00,
    sportSpecific: true,
    features: [
      '5 video analyses per month included',
      'Additional analyses: $5 each',
      'Shot analysis & Your Online Coach',
      'Expert content (Djokovic/Serena)',
      'Progress tracking'
    ]
  },
  {
    id: 'premium-golf',
    name: 'Golf Premium',
    price: 9.99,
    includedVideos: 5,
    additionalVideoPrice: 5.00,
    sportSpecific: true,
    features: [
      '5 video analyses per month included',
      'Additional analyses: $5 each',
      'Shot analysis & Your Online Coach',
      'Expert content (Ben Hogan)',
      'Progress tracking'
    ]
  },
  {
    id: 'pro',
    name: 'Pro Multi-Sport',
    price: 14.99,
    includedVideos: 10,
    additionalVideoPrice: 5.00,
    features: [
      'All sports content',
      '10 video analyses per month included',
      'Additional analyses: $5 each',
      'AI-powered coaching & Your Online Coach',
      'Progress tracking across all sports'
    ]
  }
];












